import { defineAction } from '~/prix'
import citizenFetchAction from './citizenFetch.action.json' with { type: 'json' }
import { citizenObject } from '../citizenObject'
import { z } from 'zod'
import { residenceObject } from '../../residence/residenceObject'

const residences = residenceObject.pick({
  id: true,
  title: true,
})

const citizenFetchDefinition = defineAction({
  ...citizenFetchAction,
  input: z.object({
    id: z.string().uuid(),
  }),
  output: citizenObject.extend({
    cns: z.string().nullish(),
    clientId: z.number().nullish(),
    originalId: z.string().nullish(),
    dataSourceId: z.number().nullish(),
    residences: z.array(residences).nullish(),
  }),
})

export default citizenFetchDefinition
